/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface CalendrierGlobalSearch
 */
export interface CalendrierGlobalSearch {
    /**
     * 
     * @type {number}
     * @memberof CalendrierGlobalSearch
     */
    idcentre?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof CalendrierGlobalSearch
     */
    jour?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendrierGlobalSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof CalendrierGlobalSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof CalendrierGlobalSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalendrierGlobalSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof CalendrierGlobalSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CalendrierGlobalSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the CalendrierGlobalSearch interface.
 */
export function instanceOfCalendrierGlobalSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CalendrierGlobalSearchFromJSON(json: any): CalendrierGlobalSearch {
    return CalendrierGlobalSearchFromJSONTyped(json, false);
}

export function CalendrierGlobalSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendrierGlobalSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'jour': !exists(json, 'jour') ? undefined : (json['jour'] === null ? null : new Date(json['jour'])),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function CalendrierGlobalSearchToJSON(value?: CalendrierGlobalSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcentre': value.idcentre,
        'jour': value.jour === undefined ? undefined : (value.jour === null ? null : value.jour.toISOString()),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

